import { useEffect, useRef, useState, type ReactNode } from "react";

export function usePageTransition(render: () => ReactNode, key: string): ReactNode {
  const [current, setCurrent] = useState<ReactNode>(() => render());
  const [isTransitioning, setIsTransitioning] = useState(false);
  const prevKeyRef = useRef<string>(key);

  useEffect(() => {
    if (prevKeyRef.current !== key) {
      setIsTransitioning(true);
      const timer = setTimeout(() => {
        setCurrent(render());
        setIsTransitioning(false);
        prevKeyRef.current = key;
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [key, render]);

  return (
    <div
      className={`page-transition ${isTransitioning ? "is-transitioning" : ""}`}
      data-page-key={key}
    >
      {current}
    </div>
  );
}

